function initDescSection() {

  document.querySelectorAll('.desc-section__parent').forEach(parent => {
    const toggles = [...parent.querySelectorAll('[data-js-accordion-toggle]')];

    toggles.forEach(button => {
      if (button.dataset.descBound) return;
      button.dataset.descBound = 'true';

      const content = button.closest('.desc-section__child').querySelector('[data-js-accordion-content]');
      const icon = button.querySelector('.desc-section__toggle-icon');
      if (!content) return;

      // Start state comes from aria-expanded (set server-side) rather than
      // a class, so it survives independent of this binding running.
      content.classList.toggle('is-open', button.getAttribute('aria-expanded') === 'true');

      button.addEventListener('click', () => {
        const opening = ! content.classList.contains('is-open');

        // Exclusive accordion: opening one section closes any other
        // section already open within the same block.
        if (opening) {
          toggles.forEach(otherButton => {
            if (otherButton === button) return;
            const otherContent = otherButton.closest('.desc-section__child').querySelector('[data-js-accordion-content]');
            if (otherContent && otherContent.classList.contains('is-open')) {
              otherContent.classList.remove('is-open');
              otherButton.setAttribute('aria-expanded', 'false');
              const otherIcon = otherButton.querySelector('.desc-section__toggle-icon');
              if (otherIcon) otherIcon.textContent = '+';
            }
          });
        }

        content.classList.toggle('is-open', opening);
        button.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (icon) icon.textContent = opening ? '−' : '+';
      });
    });
  });

  // Description text itself: independent of the section's own open/close
  // state above, truncated to 3 lines with its own "Show more" toggle.
  document.querySelectorAll('[data-js-desc-toggle]').forEach(button => {
    if (button.dataset.descBound) return;
    button.dataset.descBound = 'true';

    const text = button.parentElement.querySelector('[data-js-desc-text]');
    if (!text) return;

    button.addEventListener('click', () => {
      const expanded = text.classList.toggle('is-expanded');
      button.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
    });
  });

}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDescSection);
} else {
  initDescSection();
}
